function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { csv, json, text, tsv } from "d3-fetch";
import { isObject } from "@d3plus/dom";
import fold from "./fold.js";
import concat from "./concat.js";
import isData from "./isData.js";
/**
  Loads data from a filepath or URL, converts it to a valid JSON object, and returns it to a callback function.
  @param path The path to the file or url to be loaded. Also support array of paths strings. If an Array of objects is passed, the xhr request logic is skipped.
  @param formatter Optional function to transform the loaded data.
  @param key The key in the `this` context to save the resulting data to.
  @param callback Optional function called with the error and loaded data.
*/ export default function(path, formatter, key, callback) {
    var _this = this;
    var fetchData = function fetchData(path) {
        var init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ext = path.slice(path.length - 4);
        switch(ext){
            case ".csv":
                return csv(path, init);
            case ".tsv":
                return tsv(path, init);
            case ".txt":
                return text(path, init);
            default:
                return json(path, init);
        }
    };
    var validateData = function validateData(data) {
        if (data && _instanceof(data, Array)) {
            data.forEach(function(d) {
                for(var k in d){
                    var v = d[k];
                    if (typeof v === "string") {
                        if (!isNaN(v)) d[k] = parseFloat(v);
                        else if (v.toLowerCase() === "false") d[k] = false;
                        else if (v.toLowerCase() === "true") d[k] = true;
                    }
                }
            });
        }
        return data;
    };
    var loadedLength = function loadedLength(loadedArray) {
        return loadedArray.reduce(function(prev, current) {
            return current ? prev + 1 : prev;
        }, 0);
    };
    // If path param is a not an Array then convert path to a 1 element Array to re-use logic
    if (!_instanceof(path, Array)) path = [
        path
    ];
    var needToLoad = path.find(isData);
    var loaded = new Array(path.length);
    var toLoad = [];
    // If there is a string I'm assuming is a Array to merge, urls or data
    if (needToLoad) {
        path.forEach(function(dataItem, ix) {
            if (isData(dataItem)) toLoad.push(dataItem);
            else loaded[ix] = dataItem;
        });
    } else {
        loaded[0] = path;
    }
    // Load all urls an combine them with data arrays
    var alreadyLoaded = loadedLength(loaded);
    toLoad.forEach(function(dataItem) {
        var url = dataItem;
        var init = {};
        if ((typeof dataItem === "undefined" ? "undefined" : _type_of(dataItem)) === "object" && dataItem.url) {
            url = dataItem.url;
            init = dataItem;
        }
        fetchData(url, init).then(function(data) {
            if (!_instanceof(data, Array) && data.data && data.headers) data = fold(data);
            data = validateData(data);
            loaded[path.findIndex(function(d) {
                return JSON.stringify(d) == JSON.stringify(dataItem);
            })] = data;
            // All urls loaded
            if (loadedLength(loaded) - alreadyLoaded === toLoad.length) {
                // Format data
                var result = loadedLength(loaded) === 1 ? loaded[0] : loaded.filter(Boolean);
                if (_this._cache) _this._lrucache.set("".concat(key, "_").concat(url), result);
                if (formatter) {
                    var formatterResponse = formatter(loadedLength(loaded) === 1 ? loaded[0] : loaded.filter(Boolean));
                    if (key === "data" && isObject(formatterResponse)) {
                        result = formatterResponse.data || [];
                        delete formatterResponse.data;
                        _this.config(formatterResponse);
                    } else result = formatterResponse || [];
                } else if (key === "data") {
                    result = concat(loaded.filter(Boolean), "data");
                }
                if (key && "_".concat(key) in _this) _this["_".concat(key)] = result;
                if (callback) callback(undefined, result);
            }
        }).catch(function(err) {
            console.error(err);
            if (callback) callback(err, undefined);
        });
    });
    // If there is no data to Load response is immediately
    if (toLoad.length === 0) {
        loaded = loaded.map(function(data) {
            if (data && !_instanceof(data, Array) && data.data && data.headers) return fold(data);
            return data;
        });
        // Format data
        var result = loadedLength(loaded) === 1 ? loaded[0] : loaded.filter(Boolean);
        if (formatter) {
            var formatterResponse = formatter(loadedLength(loaded) === 1 ? loaded[0] : loaded.filter(Boolean));
            if (key === "data" && isObject(formatterResponse)) {
                result = formatterResponse.data || [];
                delete formatterResponse.data;
                this.config(formatterResponse);
            } else result = formatterResponse || [];
        } else if (key === "data") {
            result = concat(loaded.filter(Boolean), "data");
        }
        if (key && "_".concat(key) in this) this["_".concat(key)] = result;
        if (callback) callback(null, result);
    }
}

//# sourceMappingURL=load.js.map